import { OverlayUtil } from "@tldraw/editor";
class ZoomBrushOverlayUtil extends OverlayUtil {
  static type = "zoom_brush";
  options = { zIndex: 400, lineWidth: 1 };
  isActive() {
    return this.editor.getInstanceState().zoomBrush !== null;
  }
  getOverlays() {
    const brush = this.editor.getInstanceState().zoomBrush;
    if (!brush) return [];
    return [
      {
        id: "zoom_brush",
        type: "zoom_brush",
        props: {
          x: brush.x,
          y: brush.y,
          w: Math.max(1, brush.w),
          h: Math.max(1, brush.h)
        }
      }
    ];
  }
  render(ctx, overlays) {
    const overlay = overlays[0];
    if (!overlay) return;
    const { x, y, w, h } = overlay.props;
    const zoom = this.editor.getZoomLevel();
    const colors = this.editor.getCurrentTheme().colors[this.editor.getColorMode()];
    ctx.fillStyle = colors.brushFill;
    ctx.fillRect(x, y, w, h);
    ctx.lineWidth = this.options.lineWidth / zoom;
    ctx.strokeStyle = colors.brushStroke;
    ctx.strokeRect(x, y, w, h);
  }
  renderMinimap(ctx, overlays, zoom) {
    const overlay = overlays[0];
    if (!overlay) return;
    const { x, y, w, h } = overlay.props;
    const colors = this.editor.getCurrentTheme().colors[this.editor.getColorMode()];
    ctx.fillStyle = colors.brushFill;
    ctx.fillRect(x, y, w, h);
    ctx.lineWidth = this.options.lineWidth / zoom;
    ctx.strokeStyle = colors.brushStroke;
    ctx.strokeRect(x, y, w, h);
  }
}
export {
  ZoomBrushOverlayUtil
};
//# sourceMappingURL=ZoomBrushOverlayUtil.mjs.map
